import { QuestionCircleOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'

import { mapNumberEnumOptions } from '@eastcoal/common/utils/enums'

import { Checkbox } from '@eastcoal/formily/components/Checkbox'
import { EditableTable } from '@eastcoal/formily/components/EditableTable'
import { AddButton } from '@eastcoal/formily/components/EditableTable/components/AddButton'
import { RemoveButton } from '@eastcoal/formily/components/EditableTable/components/RemoveButton'
import { FormItem } from '@eastcoal/formily/components/FormItem'
import { InputNumber } from '@eastcoal/formily/components/InputNumber'
import { RichEditor } from '@eastcoal/formily/components/RichEditor'
import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'
import { Select } from '@eastcoal/formily/components/Select'

import { QuotaSelect } from '@eastcoal/shared/@formily/QuotaSelect'
import { MathOperatorTextMap } from '@eastcoal/shared/enums/MathOperator'

import { quotaValue1Validator } from '../validators/quotaValue1'
import { quotaValue2Validator } from '../validators/quotaValue2'

export const quotaSchema: Record<string, SchemaItem> = {
  builtinQuota: {
    type: 'boolean',
    title: '设置方式',
    enum: [
      {
        label: '模板模式',
        value: true
      },
      {
        label: '文本模式',
        value: false
      }
    ],
    'x-decorator': FormItem,
    'x-decorator-props': {
      wrapperWidth: 200
    },
    'x-component': Select,
    'x-component-props': {
      allowClear: false
    }
  },
  quotaContent: {
    type: 'string',
    'x-display': '{{ $values.builtinQuota ? "none" : "visible" }}',
    'x-decorator': FormItem,
    'x-component': RichEditor
  },
  quotaEntities: {
    type: 'array',
    'x-display': '{{ $values.builtinQuota ? "visible" : "none" }}',
    'x-decorator': FormItem,
    'x-component': EditableTable,
    items: [
      {
        name: '{ name, unit }',
        type: 'object',
        title: '指标名称',
        'x-decorator': FormItem,
        'x-component': QuotaSelect,
        'x-component-props': {
          kindId: '{{ $values.kindId }}'
        },
        'x-column-props': {
          width: 240
        }
      },
      {
        name: 'type',
        type: 'number',
        title: '区间类型',
        enum: mapNumberEnumOptions(MathOperatorTextMap),
        'x-decorator': FormItem,
        'x-component': Select,
        'x-column-props': {
          width: 160
        }
      },
      {
        name: 'value1',
        type: 'number',
        title: '最小值',
        'x-decorator': FormItem,
        'x-component': InputNumber,
        'x-validator': quotaValue1Validator
      },
      {
        name: 'value2',
        type: 'number',
        title: '最大值',
        'x-pattern': 'disabled',
        'x-decorator': FormItem,
        'x-component': InputNumber,
        'x-validator': quotaValue2Validator
      },
      {
        name: 'visible',
        type: 'boolean',
        title: (
          <>
            <span>是否显示&nbsp;</span>
            <Tooltip title='如果指标仅仅用于计算而不想向参加竞价的会员展示请取消勾选'>
              <QuestionCircleOutlined />
            </Tooltip>
          </>
        ),
        default: true,
        'x-component': Checkbox,
        'x-column-props': {
          align: 'center',
          width: 120
        }
      },
      {
        name: 'action',
        type: 'void',
        title: <AddButton />,
        'x-display': '{{$form.editable ? "visible":"none"}}',
        'x-component': RemoveButton,
        'x-column-props': {
          align: 'center',
          width: 120
        }
      }
    ]
  }
}
